import {
  Server,
  Globe,
  Settings,
  Home,
  Layers,
  Shield,
  Archive,
} from 'lucide-react';

export interface NavigationItem {
  name: string;
  href: string;
  icon: any;
  description: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    name: 'Dashboard',
    href: '/',
    icon: Home,
    description: 'Overview and system status',
  },
  {
    name: 'DNS Providers',
    href: '/providers',
    icon: Server,
    description: 'Manage DNS provider connections',
  },
  {
    name: 'DNS Zones',
    href: '/zones',
    icon: Globe,
    description: 'Configure DNS zones and records',
  },
  {
    name: 'Security',
    href: '/security',
    icon: Shield,
    description: 'DNSSEC and security settings',
  },
  {
    name: 'Backup & Restore',
    href: '/backup',
    icon: Archive,
    description: 'DNS zone backups and restore',
  },
  {
    name: 'Settings',
    href: '/settings',
    icon: Settings,
    description: 'Application preferences',
  },
];